<template>
  <div class="faq-panel">
    <div class="helptitle">Frequently asked questions</div>
    <ul class="faq-list">
      <li v-for="faq in faqs" v-bind:key="faq.id">
        <div class="helpblock">
          <div class="helplink">{{faq.link}}</div>
          <div class="helpcontent" @click="onLinkClick" v-html="faq.content"></div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
  import MixpanelMixin from "@/mixins/MixpanelMixin";
  export default {
    name: 'TwoStepFaq',
    mixins: [MixpanelMixin],
    data() {
      return {
        faqs: [
          {link: "What do I do if I have lost or forgotten my phone, or my phone is not working?",
          content: '<p>If your phone is inoperable, lost, or stolen, submit a <a class="mixpanel-link" target="_blank" href="https://autodesk.wolkenservicedesk.com/wolken-support/item_details?itemId=39&requestTypeId=3">Temporary Access Pass (TAP) request</a> for a temporary workaround that enables you to access the Autodesk network.</p><p>If you are not able to access or submit the request, reach out to your manager, a colleague, or the Enterprise Service Desk at +1 415 507 8888 and ask them to submit the TAP request on your behalf.</p>'},
          {link: "Where can I find more information about Microsoft Authenticator?",
          content: 'For information about Microsoft Authenticator, read the <a class="mixpanel-link" target="_blank" href="https://employeehub.autodesk.com/IT/articles/1e683c051b693c10ecfaec63b24bcbbc">FAQ for two-step verification using Microsoft Authenticator</a>.'},
          {link: "What if I don't have cell phone reception?",
          content: "If you are in a location with poor cell phone reception, you can still use Microsoft Authenticator by selecting the Passcode method."},
          {link: "I am a user from China. How can I register Microsoft Authenticator in Android mobile?",
          content: 'Follow the instructions in the article <a class="mixpanel-link" target="_blank" href="https://employeehub.autodesk.com/IT/articles/ad8844641b860910725aebd1b24bcbcb">Greater China Region (GCR)-specific Microsoft Authenticator enrollment instructions</a>.'},
          {link: "Who do I contact if I need help with Microsoft Authenticator or two-step verification?",
          content: "Contact the Enterprise Service Desk at +1 415 507 8888."}
        ],
      };
    },
    methods: {
      onLinkClick(event) {
        if (event.target.classList.contains('mixpanel-link')) {
          this.trackEvent(
            `Two-step verification - FAQ link clicked`,
            { subEvent: `url=${event.target.href}` }
          );
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .faq-panel /deep/ a{
    color: #5F60FF !important;
    font-family: artifaktElementBold;
  }
  .faq-panel /deep/ a:hover{
    color: #1F20BF !important;
    text-decoration: none !important;
  }
  .faq-panel {
    padding: 70px 30px 70px 60px;

    max-width: 500px;
    min-height: calc(100vh - 54px);
  }

  @media (max-width: 767px) {
    .helptitle {
      font-size: 20px;
    }
    .faq-panel {
      margin-bottom: 45px;
    }
  }
  .helptitle {
    padding-bottom: 20px;
    font-size: 26px;
    color: #000000;
    font-family: artifaktElementBold;
  }
  .faq-list {
    padding: 0 0 15px 0;
    list-style: none;
  }
  .helpblock {
    margin-bottom: 15px;
  }
  .helpcontent {
    font-size: 16px;
    color: #000000;
    margin: 0 0 30px 0;
    display: block;
    text-overflow: ellipsis;
  }
  .helplink{
    font-size: 16px;
    color: #000000;
    font-weight: bolder;
    font-family: artifaktElementBold;
  }
  @media (max-width: 576px) {
    .helpcontent {
      font-size: 14px;
    }
    .helplink{
      font-size: 14px;
    }
    .helptitle {
      font-size: 20px;
    }
    .faq-panel {
      padding: 20px;
    }
  }
  @media (max-width: 400px) {
    .helpcontent {
      font-size: 12px;
    }
    .helplink{
      font-size: 14px;
    }
    .helptitle {
      font-size: 20px;
    }
  }
</style>
